__turbopack_context__.v({
  "accessibilityItemSetContainer": "breadthofcontentaccessibilitylist-module-scss-module__wdb9wW__accessibilityItemSetContainer",
  "contentContainer": "breadthofcontentaccessibilitylist-module-scss-module__wdb9wW__contentContainer",
  "listItemsContainer": "breadthofcontentaccessibilitylist-module-scss-module__wdb9wW__listItemsContainer",
  "skipButtonContainer": "breadthofcontentaccessibilitylist-module-scss-module__wdb9wW__skipButtonContainer",
  "wrapper": "breadthofcontentaccessibilitylist-module-scss-module__wdb9wW__wrapper",
});
